import React, { useState } from "react";
import Tabs, { TabItem } from "../../../../common/components/xepp/tab/Tabs";
import UtilityPageLayout from "../../component/layout/UtilityPageLayout";
import TeamMembersTabs from "./team-members/TeamMembersTabs";
import { UtilAdminUtilityTab } from "./utility-settings/UtilAdminUtilityTab";
import DepartmentsTab from "./departments/DepartmentsTab";
import RoleManagementTab from "../../role-management/RoleManagementTab";
import { useCan } from "../../../../guards/useCan";
import { UtilityPermissions } from "../../../../model/permissions/permissions";
import { FeatureFlagName } from "../../../../tenant/features/featureFlags";
import { useFeatureFlag } from "../../../../tenant/features/useFeatureFlag";
import FeatureLockedState from "../../../../common/components/feature-locked-state/FeatureLockedState";
import { ADMIN_FEATURE_INFO } from "../../adminFeatureCatalogue";

const UtilSettingsPage: React.FC = () => {
	const [activeTab, setActiveTab] = useState("utilityTab");
	const { can } = useCan();
	const viewPermissionsOn = useFeatureFlag(FeatureFlagName.ADMIN_VIEW_PERMISSIONS);

	const tabs: TabItem[] = [
		{
			key: "utilityTab",
			label: "Utility",
			content: <UtilAdminUtilityTab />,
		},
		{
			key: "teamsTab",
			label: "Teams",
			content: <TeamMembersTabs/>
		},
		{
			key: "departmentsTab",
			label: "Department",
			content: <DepartmentsTab />
		},
		...(can(UtilityPermissions.ViewRoles)
			? [{
				key: "roleManagementTab",
				label: "Role Management",
				content: viewPermissionsOn ? (
					<RoleManagementTab />
				) : (
					<FeatureLockedState featureName={ADMIN_FEATURE_INFO[FeatureFlagName.ADMIN_VIEW_PERMISSIONS]?.title ?? "Role Management"} />
				),
			}]
			: []),
	];

	return (
		<UtilityPageLayout title="Settings" feature={FeatureFlagName.ADMIN_SERVICE_REQUEST_SETTINGS}>
			<Tabs tabs={tabs} activeTab={activeTab} onTabChange={key => setActiveTab(key)} />
		</UtilityPageLayout>
	);
};

export default UtilSettingsPage;
